module.exports = __webpack_public_path__ + "static/media/Loader_Blue.6744ad6e.svg";